import { FeatureConfig } from '@typesApp/Config'

export const baseConfig_USFlow: FeatureConfig = {
  insuranceFlowType: 'US_FLOW',
  disableInsurerConfigurationInitialFetch: true,
  contactUs: ['phone', 'chat', 'faq'],
  overviewWidgetOptions: {
    insurerLogos: ['EyeMed', 'Aetna', 'Humana', 'Cigna', 'EyeMed Plus'],
  },
}
